"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var persist_1 = require("./persist");
var scheduler_1 = __importDefault(require("./scheduler"));
var utils_1 = require("./utils");
var container_1 = __importDefault(require("../container"));
var _kernel_store_1 = __importDefault(require("./store"));
var toggleAutoStart_1 = __importDefault(require("./actions/toggleAutoStart"));
var fetchGenerationSettings_1 = __importDefault(require("./schedule/fetchGenerationSettings"));
var sendPlayState_1 = __importDefault(require("./schedule/sendPlayState"));
var fetchPoint_1 = __importDefault(require("./schedule/fetchPoint"));
var downloadMediafiles_1 = __importDefault(require("./schedule/downloadMediafiles"));
var removeExpiredNotifications_1 = __importDefault(require("./schedule/removeExpiredNotifications"));
var checkSleepState_1 = __importDefault(require("./schedule/checkSleepState"));
var regeneratePlaylistInSleepMode_1 = __importDefault(require("./schedule/regeneratePlaylistInSleepMode"));
var regeneratePlaylist_1 = __importDefault(require("./actions/generation/regeneratePlaylist"));
var checkUpcomingGenerationIsReady_1 = __importDefault(require("./actions/generation/checkUpcomingGenerationIsReady"));
var checkIsEnabledState_1 = __importDefault(require("./actions/point/checkIsEnabledState"));
var checkAutoPlay_1 = __importDefault(require("./actions/playback/checkAutoPlay"));
var lodash_flatten_1 = __importDefault(require("lodash.flatten"));
var global_1 = require("./stores/global");
var checkLoginStatus_1 = __importDefault(require("./actions/point/checkLoginStatus"));
var global_2 = require("./selectors/global");
var extensionPersist_1 = require("../adapters/extensionPersist");
var mediafiles_1 = require("./selectors/mediafiles");
var mediafilesMeta_1 = require("./stores/mediafilesMeta");
var startDownloadNextRequiredMediafile_1 = __importDefault(require("./actions/mediafiles/startDownloadNextRequiredMediafile"));
var checkPlayState_1 = __importDefault(require("./schedule/checkPlayState"));
var caching_1 = require("./selectors/caching");
var caching_2 = require("./stores/caching");
var checkReactionTasks_1 = __importDefault(require("./schedule/checkReactionTasks"));
var reactions_1 = require("./stores/reactions");
var cleanupUnusedMediafiles_1 = __importDefault(require("./actions/caching/cleanupUnusedMediafiles"));
var runners_1 = require("./scheduler/runners");
var checkDisableControls_1 = __importDefault(require("./actions/playback/checkDisableControls"));
var migrateState_1 = require("./migrateState");
var actions_1 = require("./actions");
function createDefaultReduxStore(extensions, schedulerRunnerClass) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var settings, extPersistAdapter, playerInterface, logger, schedulerLogger, needMigrateState, initialState, firstStart, schedulePeriod, throttlePersist, throttlePeriod, appName, appVersion, appUpdateChannel, autoThemeEnabled, onlyOfflineMode, kioskMode, extraMiddlewares, middlewares, extraReducers, store, scheduler, onStartupTasks;
        var _this = this;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    settings = container_1.default.get("SETTINGS");
                    extPersistAdapter = new extensionPersist_1.DefaultExtensionPersistAdapter();
                    extensions === null || extensions === void 0 ? void 0 : extensions.forEach(function (ext) {
                        if (ext.persist) {
                            extPersistAdapter.addExtension({
                                title: ext.title,
                                persist: ext.persist,
                            });
                        }
                    });
                    container_1.default.register("__EXT_PERSISTENCE", extPersistAdapter);
                    playerInterface = container_1.default.get("PLAYER");
                    logger = container_1.default.get("LOGGING").getLogger("@init");
                    schedulerLogger = container_1.default.get("LOGGING").getLogger("@scheduler");
                    needMigrateState = settings.getSetting("NEED_MIGRATE_STATE", false);
                    if (!needMigrateState) return [3, 2];
                    return [4, (0, migrateState_1.migrateState)()];
                case 1:
                    _d.sent();
                    _d.label = 2;
                case 2: return [4, (0, persist_1.getInitialState)()];
                case 3:
                    initialState = _d.sent();
                    firstStart = !initialState;
                    schedulePeriod = settings.getSetting("SCHEDULE_PERIOD", 5000);
                    throttlePersist = settings.getSetting("PERSIST_THROTTLE", true);
                    throttlePeriod = settings.getSetting("PERSIST_THROTTLE_PERIOD", 2000);
                    appName = settings.getSetting("APP_NAME");
                    appVersion = settings.getSetting("APP_VERSION");
                    appUpdateChannel = settings.getSetting("APP_UPDATE_CHANNEL");
                    autoThemeEnabled = settings.getSetting("AUTO_THEME_ENABLED", false);
                    onlyOfflineMode = settings.getSetting("PLAYER_ONLY_OFFLINE_MODE", false);
                    kioskMode = settings.getSetting("FORCE_KIOSK_MODE", false);
                    extraMiddlewares = (0, lodash_flatten_1.default)((_a = extensions === null || extensions === void 0 ? void 0 : extensions.map(function (ext) { var _a; return (_a = ext.middlewares) !== null && _a !== void 0 ? _a : []; })) !== null && _a !== void 0 ? _a : []);
                    middlewares = __spreadArray(__spreadArray([], __read(extraMiddlewares), false), [
                        playerInterface.getMiddleware(),
                        (0, utils_1.doAfter)(function (dispatch, getState) { return (0, persist_1.persistStoreState)(getState); }, {
                            throttleBy: throttlePeriod,
                            throttle: throttlePersist,
                        }),
                    ], false);
                    extraReducers = (_b = extensions === null || extensions === void 0 ? void 0 : extensions.reduce(function (collect, next) {
                        if (next.reducer) {
                            collect[next.title] = next.reducer;
                        }
                        return collect;
                    }, {})) !== null && _b !== void 0 ? _b : {};
                    store = (0, _kernel_store_1.default)(initialState, middlewares, extraReducers);
                    logger.info("Player service started", {
                        name: appName,
                        version: appVersion,
                        channel: appUpdateChannel,
                        bindingCode: (0, global_2.selectBindingCode)(store.getState()),
                    });
                    firstStart && store.dispatch((0, toggleAutoStart_1.default)(true));
                    firstStart && onlyOfflineMode && store.dispatch((0, caching_2.setBackgroundCaching)(true));
                    kioskMode && store.dispatch((0, actions_1.toggleKioskMode)(kioskMode));
                    scheduler = new scheduler_1.default(store, schedulePeriod, schedulerRunnerClass !== null && schedulerRunnerClass !== void 0 ? schedulerRunnerClass : runners_1.TimeoutRunnerProvider, schedulerLogger);
                    scheduler.addPeriodicTask(fetchPoint_1.default, {
                        runOnStart: true,
                        title: "fetchPoint",
                    });
                    scheduler.addPeriodicTask(fetchGenerationSettings_1.default, {
                        runOnStart: true,
                        title: "fetchGenerationSettings",
                    });
                    scheduler.addPeriodicTask(sendPlayState_1.default, {
                        runOnStart: true,
                        title: "sendPlayState",
                    });
                    scheduler.addPeriodicTask(checkSleepState_1.default, {
                        runOnStart: true,
                        delay: 20000,
                        title: "checkSleepState",
                    });
                    scheduler.addPeriodicTask(downloadMediafiles_1.default, {
                        runOnStart: true,
                        delay: 40000,
                        title: "downloadMediafile",
                    });
                    scheduler.addPeriodicTask(checkPlayState_1.default, {
                        delay: 20000,
                        title: "checkPlayState",
                    });
                    scheduler.addPeriodicTask(checkReactionTasks_1.default, {
                        runOnStart: true,
                        delay: 60000,
                        title: "checkReactions",
                    });
                    scheduler.addPeriodicTask(removeExpiredNotifications_1.default, {
                        title: "removeNotifications",
                    });
                    scheduler.addPeriodicTask(regeneratePlaylistInSleepMode_1.default, {
                        title: "regenerateInSleepMode",
                    });
                    extensions === null || extensions === void 0 ? void 0 : extensions.forEach(function (ext) {
                        var _a;
                        (_a = ext.periodicTasks) === null || _a === void 0 ? void 0 : _a.forEach(function (task) {
                            scheduler.addPeriodicTask(task.task, {
                                runOnStart: task.runOnStart,
                                title: task.title,
                            });
                        });
                    });
                    onStartupTasks = (_c = (extensions !== null && extensions !== void 0 ? extensions : [])) === null || _c === void 0 ? void 0 : _c.reduce(function (prev, curr) {
                        var _a;
                        prev.push.apply(prev, __spreadArray([], __read(((_a = curr === null || curr === void 0 ? void 0 : curr.onStartUpTasks) !== null && _a !== void 0 ? _a : [])), false));
                        return prev;
                    }, []);
                    scheduler.setOnStartup(function (dispatch, getState) {
                        onStartupTasks === null || onStartupTasks === void 0 ? void 0 : onStartupTasks.forEach(function (task) {
                            task.type === "preStart" && task.task(dispatch, getState);
                        });
                        var downloadingEnabled = settings.getSetting("TRACK_DOWNLOADING_ENABLED", true);
                        if (!autoThemeEnabled && firstStart) {
                            dispatch((0, global_1.setTheme)("light"));
                        }
                        dispatch({ type: "@player/init" });
                        dispatch({ type: "@control/init" });
                        dispatch((0, reactions_1.recalculateDislikes)());
                        if (downloadingEnabled && (0, caching_1.selectBackgroundCachingEnabled)(getState())) {
                            var downloadQueue = (0, mediafiles_1.selectFilesForDownloading)(getState()).map(function (file) { return file.mediafileId; });
                            dispatch((0, mediafilesMeta_1.setMediafileDownloadQueue)(downloadQueue));
                            dispatch((0, startDownloadNextRequiredMediafile_1.default)());
                        }
                        dispatch((0, cleanupUnusedMediafiles_1.default)());
                        dispatch((0, checkLoginStatus_1.default)());
                        dispatch((0, regeneratePlaylist_1.default)());
                        dispatch((0, checkUpcomingGenerationIsReady_1.default)());
                        dispatch((0, checkIsEnabledState_1.default)(true));
                        dispatch((0, checkDisableControls_1.default)());
                        dispatch((0, checkAutoPlay_1.default)());
                        onStartupTasks === null || onStartupTasks === void 0 ? void 0 : onStartupTasks.forEach(function (task) {
                            task.type === "postStart" && task.task(dispatch, getState);
                        });
                    });
                    store.initialize = function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                        return [2, store];
                    }); }); };
                    return [2, [store, scheduler]];
            }
        });
    });
}
exports.default = createDefaultReduxStore;
//# sourceMappingURL=create-store.js.map